// ABOUTME: Full-screen mobile overlay menu with all navigation items
// ABOUTME: Shown when hamburger menu is open, renders MenuDropdown with all tabs
import { MenuDropdown } from "@hm/fundamental"
import React from "react"

import { useNavigationContext } from "../NavigationContext"

export const MobileOverlay: React.FC = () => {
	const { menuItems, menuRef, closeMobileMenu } = useNavigationContext()

	return (
		<div className="fixed inset-x-0 top-[64px] bottom-0 z-[9999] bg-page_background">
			<div className="h-full p-4 flex flex-col">
				<div
					ref={menuRef}
					className="bg-container_background rounded-lg shadow-user_menu flex flex-col"
				>
					<div className="flex-1 py-3 overflow-auto">
						<MenuDropdown
							items={menuItems}
							closeMenu={closeMobileMenu}
							fullWidth
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
